
import { defineComponent } from 'vue';
import AppSignIn from '@/components/AppSignIn.vue';
import AppNoAuthContainer from '@/components/AppNoAuthContainer.vue';

export default defineComponent({
  name: 'SignIn',
  components: {
    AppSignIn,
    AppNoAuthContainer
  }
});
